export default {
  common: {
    view: "Ko'rish",
    save: 'Saqlash',
    cancel: 'Bekor qilish',
    delete: "O'chirish",
    reset: "O'chirish",
    edit: 'Tahrirlash',
    create: 'Yaratish',
    close: 'Yopish',
    next: 'Keyingi',
    back: 'Orqaga',
    search: 'Qidirish',
    upload: 'Yuklash',
    download: 'Yuklab olish',
    downloadAll: 'Hammasini yuklab olish',
    confirm: 'Tasdiqlash',
    all: 'Barchasi',
    loading: 'Yuklanmoqda...',
    noData: "Ma'lumot topilmadi",
    error: 'Xatolik',
    success: 'Muvaffaqiyat',
  },

  layout: {
    savat: 'Savat',
    dv: "Green Card (DV)",
    brand: 'Oasis Visa CRM',
    dashboard: 'Dashboard',
    tasks: 'Vazifalar',
    clients: 'Clientlar',
    tekshiruv: 'Tekshirish',
    vacancies: 'Vakansiyalar',
    partners: 'Hamkorlar',
    employees: 'Xodimlar',
    monitoring: 'Monitoring',
    settings: 'Sozlamalar',
    profile: 'Profil',
    logout: 'Chiqish',
    logoutSuccess: 'Tizimdan chiqdingiz',
    newClient: 'Yangi client',
    botSurveys: 'Bot anketalar',
    cvBuilder: 'CV Builder',
    emailMarketing: 'Email Marketing',
    scrapedJobs: 'Ish e\'lonlari',
    calendar: 'Kalendar',
    notifications: 'Bildirishnomalar',
    admin: 'Administrator',
    employee: 'Xodim',
    expand: 'Kengaytirish',
    collapse: 'Yig\'ish',
    cases: 'Ishlar (Cases)',
    casesDashboard: 'Dashboard (Cases)',
  },

  notifications: {
    title: 'Bildirishnomalar',
    all: 'Barchasi',
    unread: 'O\'qilmagan',
    tasks: 'Vazifalar',
    system: 'Tizim',
    markAllRead: 'Hammasini o\'qilgan',
    cleanOld: 'Eskilarni tozalash',
    viewAll: 'Barchasini ko\'rish',
    telegramUlash: 'Telegramga ulash',
    telegramUlangan: 'Telegram ulangan',
    telegramUzish: 'Bosilsa — Telegram uziladi',
    telegramYoriqnoma: "Telegramda botni oching va «Start» ni bosing — havola {n} daqiqa amal qiladi",
    telegramXato: "Telegram ulanmadi — keyinroq urinib ko'ring",
    noNotifications: 'Bildirishnomalar yo\'q',
    noUnread: 'O\'qilmagan bildirishnomalar yo\'q',
    markAsRead: 'O\'qilgan deb belgilash',
    deleteNotif: 'O\'chirish',
    now: 'Hozir',
    minutesAgo: '{n} daqiqa oldin',
    hoursAgo: '{n} soat oldin',
    daysAgo: '{n} kun oldin',
    markAllSuccess: 'Barcha bildirishnomalar o\'qilgan deb belgilandi',
    errorGeneric: 'Xato yuz berdi',
    confirmClean: "30 kundan eski o'qilgan bildirishnomalar o'chiriladi. Davom etasizmi?",
    confirmCleanTitle: 'Tasdiqlash',
    yesDelete: "Ha, o'chirish",
    cancelBtn: 'Bekor qilish',
    typeTask: 'Vazifa',
    typeCompleted: 'Bajarildi',
    typeApproved: 'Tasdiqlandi',
    typeOverdue: "Muddati o'tdi",
    typeComment: 'Izoh',
    typeClient: 'Mijoz',
    typeSystem: 'Tizim',
    typeReminder: 'Eslatma',
    newVacancy: 'Korxonada yangi vakansiya!',
    taskCompleted: 'Vazifa bajarildi',
    taskAssigned: 'Vazifa biriktirildi',
    taskReviewed: "Vazifa ko'rib chiqildi",
    callbackInMinutes: "Qayta qo'ng'iroq ({n} daqiqadan keyin)",
    callbackOn: "Qayta qo'ng'iroq: {name}",
    taskDoneBy: '"{task}" vazifasi {user} tomonidan bajarildi',
    callNoAnswer: "Ko'tarmadi",
    callCallback: "Qayta qo'ng'iroq",
    callAnswered: 'Javob berdi',
    callBusy: 'Band',
    callSuccess: 'Muvaffaqiyatli',
    callRejected: 'Rad etdi',
  },

  calendar: {
    today: 'Bugun',
    allStatuses: 'Barcha holatlar',
    allPriorities: 'Barcha ustuvorliklar',
    more: 'ta yana',
    noEvents: 'Voqealar yo\'q',
    tasks: 'ta vazifa',
    startDate: 'Boshlanish',
    dueDate: 'Muddat',
    dueTime: 'Vaqt',
    assignee: 'Ijrochi',
    description: 'Tavsif',
    goToTask: 'Vazifaga o\'tish',
    viewMonth: 'Oylik',
    viewWeek: 'Haftalik',
    viewList: "Ro'yxat",
    statusNew: 'Yangi',
    statusInProgress: 'Jarayonda',
    statusCompleted: 'Bajarildi',
    statusApproved: 'Tasdiqlandi',
    prioLow: 'Past',
    prioMedium: "O'rta",
    prioHigh: 'Yuqori',
    prioUrgent: 'Shoshilinch',
    dayMon: 'Du', dayTue: 'Se', dayWed: 'Ch', dayThu: 'Pa', dayFri: 'Ju', daySat: 'Sh', daySun: 'Ya',
    shortSun: 'Yak', shortMon: 'Du', shortTue: 'Se', shortWed: 'Ch', shortThu: 'Pa', shortFri: 'Ju', shortSat: 'Sh',
    monthShortJan: 'Yan', monthShortFeb: 'Fev', monthShortMar: 'Mar', monthShortApr: 'Apr',
    monthShortMay: 'May', monthShortJun: 'Iyn', monthShortJul: 'Iyl', monthShortAug: 'Avg',
    monthShortSep: 'Sen', monthShortOct: 'Okt', monthShortNov: 'Noy', monthShortDec: 'Dek',
    monthJan: 'Yanvar', monthFeb: 'Fevral', monthMar: 'Mart', monthApr: 'Aprel',
    monthMay: 'May', monthJun: 'Iyun', monthJul: 'Iyul', monthAug: 'Avgust',
    monthSep: 'Sentabr', monthOct: 'Oktabr', monthNov: 'Noyabr', monthDec: 'Dekabr',
    addEvent: "Event qo'shish",
    eventName: 'Nomi',
    eventNamePh: 'Event nomi',
    dateLabel: 'Sana',
    timeLabel: 'Vaqti',
    priorityLabel: 'Ustuvorlik',
    visibility: "Ko'rinish",
    onlyMe: 'Faqat menga',
    everyone: 'Hammaga',
    selectEmployee: 'Xodimni tanlang',
    noteLabel: 'Izoh',
    notePh: "Qo'shimcha izoh...",
    cancel: 'Bekor',
    save: 'Saqlash',
    eventSaved: 'Event saqlandi!',
    eventDeleted: "Event o'chirildi",
    errorGeneric: 'Xatolik yuz berdi',
    confirmDeleteTitle: "O'chirish",
    confirmDeleteMsg: '"{title}" event o\'chirilsinmi?',
    yes: 'Ha',
    createdBy: 'Yaratuvchi',
    adminBadge: 'Rahbar',
    goToVacancy: "Vakansiyaga o'tish",
    deleteBtn: "O'chirish",
  },

  login: {
    title: 'AgentsVA CRM',
    subtitle: 'Tizimga kirish',
    username: 'Username',
    password: 'Parol',
    loginButton: 'Kirish',
    loggingIn: 'Kirish...',
    welcome: 'Xush kelibsiz!',
    invalidCredentials: "Login yoki parol noto'g'ri",
    usernameRequired: 'Username kiriting',
    passwordRequired: 'Parol kiriting',
  },

  dashboard: {
    totalTasks: 'Jami vazifalar',
    approved: 'Tasdiqlangan',
    inProgress: 'Jarayonda',
    totalClients: 'Jami clientlar',
    recentTasks: "So'nggi vazifalar",
    recentClients: "So'nggi clientlar",
    task: 'Vazifa',
    status: 'Status',
    firstName: 'Ism',
    lastName: 'Familiya',
    country: 'Davlat',
    viewAll: 'Barchasini ko\'rish',
    loadError: "Ma'lumotlarni yuklashda xatolik",
    quickActions: 'Tezkor amallar',
    addClient: 'Yangi client',
    viewVacancies: 'Vakansiyalar',
    cvBuilder: 'CV yaratish',
    botSurveys: 'Bot anketalar',
    noTasks: 'Vazifalar yo\'q',
    noClients: 'Clientlar yo\'q',
    statTasks: 'Vazifalar',
    statNew: 'Yangi',
    statInProgress: 'Jarayonda',
    statApproved: 'Tasdiqlangan',
    statClients: 'Clientlar',
    statVacancies: 'Vakansiyalar',
    statMyPartners: 'Hamkorlarim',
    statMyClients: 'Clientlarim',
    greetingNight: 'Assalomu alaykum',
    greetingMorning: 'Xayrli tong',
    greetingDay: 'Xayrli kun',
    greetingEvening: 'Xayrli kech',
    monthJan: 'Yanvar', monthFeb: 'Fevral', monthMar: 'Mart', monthApr: 'Aprel',
    monthMay: 'May', monthJun: 'Iyun', monthJul: 'Iyul', monthAug: 'Avgust',
    monthSep: 'Sentabr', monthOct: 'Oktabr', monthNov: 'Noyabr', monthDec: 'Dekabr',
    daySun: 'Yakshanba', dayMon: 'Dushanba', dayTue: 'Seshanba', dayWed: 'Chorshanba',
    dayThu: 'Payshanba', dayFri: 'Juma', daySat: 'Shanba',
    allLink: 'Barchasi',
    greetingNight: 'Assalomu alaykum',
    greetingMorning: 'Xayrli tong',
    greetingDay: 'Xayrli kun',
    greetingEvening: 'Xayrli kech',
    monthJan: 'Yanvar', monthFeb: 'Fevral', monthMar: 'Mart', monthApr: 'Aprel',
    monthMay: 'May', monthJun: 'Iyun', monthJul: 'Iyul', monthAug: 'Avgust',
    monthSep: 'Sentabr', monthOct: 'Oktabr', monthNov: 'Noyabr', monthDec: 'Dekabr',
    daySun: 'Yakshanba', dayMon: 'Dushanba', dayTue: 'Seshanba', dayWed: 'Chorshanba',
    dayThu: 'Payshanba', dayFri: 'Juma', daySat: 'Shanba',
    cStatusYangi: 'Yangi',
    cStatusHujjat: 'Hujjat',
    cStatusTayyor: 'Tayyor',
    cStatusKutilmoqda: 'Kutilmoqda',
    cStatusVizaOldi: 'Viza oldi',
    cStatusJonatildi: "Jo'natildi",
    cStatusBekor: 'Bekor',
  },

  chat: {
    title: 'Chat',
    searchPlaceholder: 'Qidirish...',
    searchChat: 'Chat qidirish...',
    newChat: 'Yangi chat',
    newGroup: 'Yangi guruh',
    myChats: 'Mening chatlarim',
    allChats: 'Barchasi',
    noChats: 'Chatlar yo\'q',
    noMessages: 'Xabarlar yo\'q',
    typeMessage: 'Xabar yozing...',
    send: 'Yuborish',
    attach: 'Fayl biriktirish',
    emoji: 'Smayliklar',
    mention: 'Tilga olish',
    share: 'Ulashish',
    shareVacancy: 'Vakansiyani ulashish',
    shareClient: 'Clientni ulashish',
    selectMember: 'A\'zo tanlang',
    addMember: 'A\'zo qo\'shish',
    removeMember: 'A\'zoni o\'chirish',
    leaveGroup: 'Guruhdan chiqish',
    deleteChat: 'Chatni o\'chirish',
    chatName: 'Chat nomi',
    groupName: 'Guruh nomi',
    members: 'A\'zolar',
    membersCount: '{count} a\'zo',
    online: 'Onlayn',
    offline: 'Oflayn',
    typing: 'Yozmoqda...',
    edit: 'Tahrirlash',
    delete: 'O\'chirish',
    reply: 'Javob berish',
    copy: 'Nusxalash',
    forward: 'Yo\'naltirish',
    messageDeleted: 'Xabar o\'chirildi',
    messageEdited: 'tahrirlangan',
    confirmDeleteMsg: 'Bu xabarni o\'chirmoqchimisiz?',
    confirmDeleteChat: 'Bu chatni o\'chirmoqchimisiz?',
    confirmLeaveGroup: 'Guruhdan chiqmoqchimisiz?',
    chatCreated: 'Chat yaratildi',
    createError: 'Chat yaratishda xatolik',
    sendError: 'Xabar yuborishda xatolik',
    fileTooLarge: 'Fayl hajmi juda katta (max 25MB)',
    fileUploadError: 'Faylni yuklashda xatolik',
    searchUser: 'Hodim qidirish...',
    select: 'Tanlash',
    createChat: 'Chatni yaratish',
    create: 'Yaratish',
    cancel: 'Bekor',
    confirm: 'Tasdiqlash',
    today: 'Bugun',
    yesterday: 'Kecha',
    selectChat: 'Chatni tanlang',
    selectChatHint: 'Xabar yozish uchun chap tomondagi chatni tanlang',
    groupInfo: 'Guruh haqida',
    privateChat: 'Shaxsiy chat',
    groupChat: 'Guruh chat',
    me: 'Men',
    you: 'Siz',
    unreadMessages: 'o\'qilmagan xabar',
    replyTo: 'Javob',
    writeMessage: 'Xabar yozing...',
    uploadImage: 'Rasm yuklash',
    uploadFile: 'Fayl yuklash',
    sharedVacancy: 'Ulashilgan vakansiya',
    sharedClient: 'Ulashilgan client',
    viewDetails: 'Batafsil ko\'rish',
    addEmoji: 'Smayl qo\'shish',
    loadingMessages: 'Xabarlar yuklanmoqda...',
    loadMore: 'Yana yuklash',
    photo: 'Rasm',
    file: 'Fayl',
    noResults: 'Natija topilmadi',
    groupsSection: 'Guruhlar',
    privateSection: 'Shaxsiy chatlar',
    messagesShort: 'xabar',
    emptyShort: "bo'sh",
    settings: 'Sozlamalar',
    retry: 'Qayta yuborish',
    attachImageFile: 'Rasm/fayl',
    vacancyKind: 'Vakansiya',
    clientKind: 'Client',
    searchVacancyPlaceholder: 'Vakansiya nomi qidiring...',
    searchClientPlaceholder: "Client ism/familiya...",
    enterSearchHint: "Qidiruv so'zini kiriting",
    addMemberPh: "A'zo qo'shish...",
    addBtn: "Qo'shish",
    removeBtn: 'Chiqarish',
    adminTag: 'Admin',
    saveBtn: 'Saqlash',
    clearMessages: 'Yozishmalarni tozalash',
    deleteAllMessages: "Barcha xabarlarni o'chirish",
    dangerZone: 'Xavfli zona',
    deleteChatCompletely: "Chatni butunlay o'chirish",
    adminCleanup: 'Admin: Eski xabarlarni tozalash',
    olderThan: '{n} kundan eski',
    deleteAllNow: 'Barchasini darhol',
    editMessage: 'Xabarni tahrirlash',
  },

  partners: {
    title: 'Hamkorlar',
    total: 'Jami',
    statusNew: 'Yangi',
    statusRegular: 'Doimiy',
    statusPremium: 'Premium',
    statusVip: 'VIP',
    dirWork: 'Ish',
    dirStudy: 'Ta\'lim',
    dirTravel: 'Sayohat',
    dirAvia: 'Avia',
    filterAll: 'Hammasi',
    filterDir: 'Yo\'nalish',
    filterCountry: 'Davlat',
    filterStatusLabel: 'Holat',
    filterCategory: 'Toifa',
    filterEmployee: 'Hodim',
    partnerStatusTitle: 'Hamkorlik statusi',
    trustLevel: 'Ishonchlilik',
    category: 'Toifa',
    employee: 'Hodim',
    categoryAgency: 'Agentlik',
    categoryDirect: "To'g'ri",
    categoryScammer: 'Firibgar',
    categoryUnknown: 'Noma\'lum',
    vacancyLabel: 'Vakansiya',
    vacancyName: 'Vakansiya nomi',
    companyName: 'Kompaniya',
    dateLabel: 'Sana',
    vacancyDescription: "Qo'shimcha ma'lumot...",
    saveFilter: 'Filtrni saqlash',
    removeFilter: 'Filtrni o\'chirish',
    addPartner: 'Hamkor qo\'shish',
    editPartner: 'Hamkorni tahrirlash',
    partnerAddSuccess: 'Hamkor qo\'shildi',
    partnerAlreadyExists: "Bu kontakt allaqachon hamkorlar ro'yxatida: \"{name}\"",
    confirmRemove: "\"{title}\" hamkorlikdan chiqarilsinmi?",
    confirmRemoveTitle: 'Hamkorlikni bekor qilish',
    yesRemove: 'Ha, bekor qilish',
    noCancel: "Yo'q",
    removeSuccess: 'Hamkorlik bekor qilindi',
    bulkSelected: '{count} tanlandi',
    bulkAssignEmployees: 'Hodimlar',
    bulkNotAssigned: '— Biriktirilmagan —',
    bulkAssignBtn: 'Biriktirish',
    bulkAssignSuccess: '{count} ta hamkor biriktirildi',
    bulkAssignCancelled: 'Biriktirish bekor qilindi',
    saved: 'Saqlandi',
    errorGeneric: 'Xatolik yuz berdi',
    totalVacancies: 'Jami vakansiyalar',
    activePartners: 'Faol hamkorlar',
    assigned: 'Biriktirilgan',
    newPartner: 'Yangi hamkor',
    searchPlaceholder: 'Vakansiya, kompaniya qidirish...',
    companyName: 'Kompaniya nomi',
    contactPerson: 'Aloqa shaxsi',
    phone: 'Telefon',
    email: 'Email',
    website: 'Veb-sayt',
    address: 'Manzil',
    country: 'Davlat',
    city: 'Shahar',
    jobTitle: 'Vakansiya nomi',
    description: 'Tavsif',
    notes: 'Izohlar',
    status: 'Holat',
    assignedTo: 'Biriktirilgan',
    additionalAssignees: 'Qo\'shimcha xodimlar',
    linkedClients: 'Biriktirilgan mijozlar',
    linkClient: 'Client biriktirish',
    unlinkClient: 'Client olib tashlash',
    selectClients: 'Clientlarni tanlang',
    noLinkedClients: 'Biriktirilgan clientlar yo\'q',
    multiAssignTitle: 'Ko\'p hodim biriktirish',
    selectAssignees: 'Xodimlarni tanlang',
    assignPartner: 'Hamkor biriktirish',
    assignPartnerHint: 'Bu vakansiya sizga biriktirildi',
    callPhone: 'Qo\'ng\'iroq qilish',
    sendEmail: 'Email yuborish',
    openWebsite: 'Saytni ochish',
    view: 'Ko\'rish',
    edit: 'Tahrirlash',
    delete: 'O\'chirish',
    save: 'Saqlash',
    cancel: 'Bekor',
    confirmDelete: 'Bu hamkorni o\'chirmoqchimisiz?',
    confirmUnlink: 'Clientni olib tashlamoqchimisiz?',
    deleteSuccess: 'Hamkor o\'chirildi',
    deleteError: 'O\'chirishda xatolik',
    saveSuccess: 'Saqlandi',
    saveError: 'Saqlashda xatolik',
    assignSuccess: 'Biriktirildi',
    assignError: 'Biriktirishda xatolik',
    linkSuccess: 'Client biriktirildi',
    unlinkSuccess: 'Client olib tashlandi',
    noPartners: 'Hamkorlar yo\'q',
    loadError: 'Ma\'lumotlarni yuklashda xatolik',
    openDetails: 'Batafsil',
    close: 'Yopish',
    postedAt: 'E\'lon sanasi',
    source: 'Manba',
    sourceLink: 'Havola',
    category: 'Kategoriya',
    myPartners: 'Mening hamkorlarim',
    allPartners: 'Barcha hamkorlar',
    filterCountry: 'Davlat bo\'yicha',
    filterStatus: 'Holat bo\'yicha',
    actions: 'Amallar',
    viewVacancy: 'Vakansiyani ko\'rish',
    assigneeLabel: 'Biriktirilgan xodim',
    additionalLabel: 'Qo\'shimcha hodimlar',
    noAssignee: 'Biriktirilmagan',
    selectClientsPlaceholder: 'Clientlarni qidiring va tanlang',
    clientSelected: '{count} ta client tanlandi',
    apply: 'Tasdiqlash',
  },

  status: {
    new: 'Yangi',
    in_progress: 'Jarayonda',
    completed: 'Bajarildi',
    approved: 'Tasdiqlandi',
  },

  priority: {
    low: 'Past',
    medium: "O'rta",
    high: 'Yuqori',
    urgent: 'Shoshilinch',
  },

  tasks: {
    title: 'Vazifalar',
    newTask: 'Yangi vazifa',
    all: 'Barchasi',
    new: 'Yangi',
    inProgress: 'Jarayonda',
    completed: 'Bajarilgan',
    approved: 'Tasdiqlangan',
    employee: 'Xodim',
    statusCol: 'Status',
    priorityCol: 'Ustuvorlik',
    deadline: 'Muddat',
    actions: 'Amallar',
    start: 'Boshlash',
    complete: 'Bajarish',
    approve: 'Tasdiqlash',
    taskStarted: 'Vazifa boshlandi',
    confirmComplete: "Vazifani bajarilgan deb belgilaysizmi?",
    confirmCompleteTitle: 'Tasdiqlash',
    taskCompleted: 'Vazifa bajarildi',
    confirmApprove: "Vazifani tasdiqlaysizmi?",
    confirmApproveTitle: 'Tasdiqlash',
    taskApproved: 'Vazifa tasdiqlandi',
    noTasks: "Vazifalar yo'q",
  },

  taskDetail: {
    result: 'Bajarilgan ish natijasi',
    noResult: 'Natija yuklanmagan',
    addResult: 'Fayl / ekran surati',
    resultHint: "Bajarganingizni ko'rsatuvchi fayl yoki ekran surati",
    resultUploaded: 'Natija yuklandi',
    resultPartial: '{n} ta fayl yuklanmadi',
    resultDeleted: 'Natija o‘chirildi',
    deleteResultConfirm: '{name} o‘chiriladi. Davom etamizmi?',
    description: 'Tavsif',
    assignedTo: 'Biriktirilgan xodim',
    createdBy: 'Yaratgan',
    startDate: 'Boshlanish sanasi',
    dueDate: 'Muddat',
    createdAt: 'Yaratilgan sana',
    completedAt: 'Bajarilgan vaqt',
    comments: 'Izohlar',
    noComments: "Izohlar yo'q",
    addComment: 'Izoh yozing...',
    send: 'Yuborish',
    commentAdded: 'Izoh qo\'shildi',
  },

  taskCreate: {
    title: 'Yangi vazifa yaratish',
    taskName: 'Vazifa nomi',
    description: 'Tavsif',
    employee: 'Xodim',
    employeePlaceholder: 'Xodimni tanlang',
    priority: 'Ustuvorlik',
    startDate: 'Boshlanish sanasi',
    dueDate: 'Muddat sanasi',
    dueTime: 'Muddat vaqti',
    create: 'Yaratish',
    cancel: 'Bekor',
    taskNameRequired: 'Vazifa nomini kiriting',
    descriptionRequired: 'Tavsifni kiriting',
    employeeRequired: 'Xodimni tanlang',
    startDateRequired: 'Boshlanish sanasini tanlang',
    dueDateRequired: 'Muddat sanasini tanlang',
    dueTimeRequired: 'Muddat vaqtini tanlang',
    createSuccess: 'Vazifa yaratildi',
    createError: 'Vazifa yaratishda xatolik',
    loadEmployeesError: "Xodimlarni yuklashda xatolik",
  },

  slot: {
    title: 'Slot',
    ustun: 'Slot',
    yoq: "Slot hali olinmagan — olinganda shu yerga kiriting: sana, soat va joy",
    qosh: "Slot qo'shish",
    qoshYana: "Yana slot qo'shish",
    joyYoq: 'Joy kiritilmagan',
    joyMisol: 'Masalan: Estoniya elchixonasi yoki VFS Global (Toshkent)',
    anketa: 'Anketa',
    bordi: 'Bordi',
    kelmadi: 'Kelmadi',
    kochir: "Ko'chirish",
    tahrir: 'Tahrirlash',
    bekor: 'Bekor qilish',
    yana: 'Boshqa amallar',
    bekorSavol: "Slot bekor qilinsinmi? Eslatmalar to'xtaydi.",
    tarix: 'Boshqa slotlar ({n})',
    sana: 'Sana',
    soat: 'Soat',
    joy: 'Joy (elchixona / viza markazi)',
    manzil: 'Manzil',
    maqsad: 'Maqsad',
    izoh: 'Izoh',
    saqlandi: 'Slot saqlandi — eslatmalar avtomatik yuboriladi',
    holatQoyildi: 'Holat belgilandi',
    xato: 'Saqlanmadi',
    shakl: { yangi: 'Yangi slot', tahrir: 'Slotni tahrirlash', kochir: "Slotni ko'chirish — yangi sana" },
    maqsadlar: { topshirish: 'Hujjat topshirish', biometrika: 'Biometrika', intervyu: 'Intervyu', olish: 'Pasport / viza olish' },
    qoldi: { otdi: "Vaqti o'tdi — holatini belgilang", bugun: 'Bugun, {soat}', ertaga: 'Ertaga, {soat}', kun: '{n} kun qoldi' },
  },
  tekshiruv: {
    title: 'Tekshirish navbati',
    subtitle: "Hujjatlardan kartaga avtomatik yozilgan, lekin xodim hali ko'rmagan qiymatlar. Hujjat bilan solishtiring: to'g'ri bo'lsa — tasdiqlang, xato bo'lsa — tuzating yoki hujjatdagi boshqa qiymatni tanlang. Anketaga faqat tekshirilgan ma'lumot ketishi kerak.",
    kimniki: 'Qaysi clientlar',
    daraja: 'Ishonch darajasi',
    mening: 'Mening clientlarim',
    barcha: 'Barcha clientlar',
    hammasi: 'Hammasi',
    jami: '{n} ta qiymat · {m} ta client',
    bosh: "Tekshiradigan qiymat yo'q — hammasi ko'rilgan",
    boshMening: "Sizning clientlaringizda tekshiradigan qiymat yo'q",
    masul: "Mas'ul: {name}",
    hujjat: 'Manba hujjat',
    pdfOch: 'PDF ni ochish',
    togri: "To'g'ri",
    yuqorilar: 'Yuqorilarni tasdiqlash ({n})',
    tasdiqlandi: '{n} ta qiymat tasdiqlandi',
    saqlandi: 'Tuzatildi va saqlandi',
    tanlandi: '{field}: hujjatdagi qiymat yozildi',
    xato: 'Saqlanmadi — qayta urinib ko\'ring',
  },
  savat: {
    title: 'Savat',
    subtitle: "O'chirilgan mijozlar shu yerda turadi — hujjatlari, faktlari va keyslari bilan. «Qaytarish» "
      + "ularni bir bosishda avvalgi holiga qaytaradi.",
    bosh: "Savat bo'sh",
    mijoz: 'Mijoz',
    qachon: "O'chirilgan vaqt",
    kim: "Kim o'chirgan",
    hujjatlar: 'Hujjatlar',
    qaytarish: 'Qaytarish',
    qaytarildi: '{ism} qaytarildi',
    faqatAdmin: "Savat faqat admin uchun",
  },
  hujjatSavat: {
    tugma: 'Savat ({n})',
    title: 'Hujjatlar savati',
    subtitle: "O'chirilgan hujjatlar shu yerda — fayli va o'qilgan ma'lumotlari bilan. «Qaytarish» hujjatni "
      + "avvalgi joyiga qaytaradi. Savatdagi hujjat anketa, CC va Claude ga ko'rinmaydi.",
    bosh: "Savat bo'sh",
    qachon: "O'chirilgan vaqt",
    kim: "Kim o'chirgan",
    sabab: 'Sabab',
    korish: "Ko'rish",
    qaytarish: 'Qaytarish',
    qaytarildi: '{tur} qaytarildi',
    butunlay: "Butunlay o'chirish",
    butunlayTasdiq: "Hujjat va fayli BUTUNLAY o'chadi — qaytarib bo'lmaydi. Tasdiqlash uchun «{soz}» deb yozing:",
    sozMosEmas: "Tasdiq so'zi mos emas",
    ochirildi: "Hujjat butunlay o'chirildi",
  },
  clients: {
    olaman: 'Men olaman',
    olindi: 'Mijoz sizga biriktirildi',
    allaqachonOlingan: 'Bu mijozni boshqa xodim allaqachon olgan: {kim}',
    savatgaTasdiq: "Mijoz savatga tushadi — «Savat» bo'limidan bir bosishda qaytariladi. Tasdiqlash uchun mijozning to'liq ismini yozing: {ism}",
    savatgaTashlash: 'Savatga tashlash',
    ismMosEmas: 'Ism mos emas — mijozning ismi va familiyasini yozing',
    savatgaTushdi: "{ism} savatga tushdi — «Savat» dan qaytarish mumkin",
    bulkLinkSuccess: '{clients} ta mijoz {partners} ta hamkorga biriktirildi',
    bulkAssignSuccess: '{count} ta client biriktirildi',
    bulkAssignCancelled: 'Biriktirish bekor qilindi',
    bulkNotAssigned: '— Biriktirilmagan —',
    employeesLabel: 'Hodimlar',
    assignBtn: 'Biriktirish',
    linkToPartner: 'Hamkorga biriktirish',
    selectedCount: '{count} tanlandi',
    errorGeneric: 'Xatolik',
    title: 'Clientlar',
    scope: {
      label: 'Qaysi clientlar',
      all: 'Barcha clientlar',
      mine: 'Mening clientlarim',
      mineHint: "Sizga biriktirilgan clientlar — asosiy mas'ul yoki qo'shimcha biriktirilgan xodim sifatida",
      co: "qo'shimcha",
      coHint: "Siz bu clientga qo'shimcha biriktirilgansiz (asosiy mas'ul — boshqa xodim)",
      mineEmpty: 'Sizga hali client biriktirilmagan',
    },
    newClient: 'Yangi client',
    searchPlaceholder: 'Ism, familiya, passport...',
    fullName: 'Ism Familiya',
    passport: 'Passport',
    phone: 'Telefon',
    country: 'Davlat',
    travelPurpose: 'Maqsad',
    direction: "Yo'nalish",
    status: 'Status',
    employee: 'Xodim',
    all: 'Barchasi',
    registeredBy: "Ro'yxatdan o'tkazgan",
    date: 'Sana',
    actions: 'Amallar',
    view: "Ko'rish",
    delete: "O'chirish",
    confirmDelete: "ni o'chirmoqchimisiz?",
    confirmDeleteTitle: 'Tasdiqlash',
    deleteSuccess: "Client o'chirildi",
    searchError: 'Qidirishda xatolik',
    noSearchResults: 'Natija topilmadi',
    noClients: "Clientlar yo'q",
    uploadPhoto: 'Rasm yuklash (bosing)',
    photoUploaded: 'Rasm muvaffaqiyatli yuklandi',
    photoUploadError: 'Rasm yuklashda xatolik',
    workInfo: 'Kasb / OTM',
    notes: 'Izoh',
    addNote: 'Izoh qo\'shing...',
    noteSaved: 'Izoh saqlandi',
    noteError: 'Izoh saqlashda xatolik',
    noWorkInfo: '\u2014',
    ov: {
      total: 'Jami mijozlar',
      totalSub: "{countries} ta davlat · {directions} ta yo'nalish",
      active: 'Jarayonda',
      activeHint: "Yangi, hujjat yig'ilmoqda, hujjatlar tayyor va viza kutilmoqda",
      success: 'Viza olindi',
      successHint: "Viza oldi va jo'natildi",
      cancelled: 'Bekor qilingan',
      ofTotal: '{p}% jami mijozlardan',
      pipeline: 'Mijozlar jarayoni',
      pipelineHint: "Bosqichni bosing — ro'yxat shu bosqich bo'yicha filtrlanadi",
      directions: "Yo'nalishlar",
      countries: "Ko'p davlatlar",
      noData: "Ma'lumot yo'q",
      docsMissing: '{n} ta yetishmaydi',
      docsComplete: "Hammasi to'plangan",
      docsMissingTitle: 'Yetishmayotgan hujjatlar:',
      stepOf: '{i}-bosqich, jami {n} ta',
    },
  },

  travelPurpose: {
    work: 'Ish',
    study: "O'qish",
    tourism: 'Turizm',
    business: 'Biznes',
    other: 'Boshqa',
  },

  direction: {
    ish: 'Ish',
    oqish: "O'qish",
    sayohat: 'Sayohat',
    biznes: 'Biznes',
    boshqa: 'Boshqa',
  },

  clientStatus: {
    yangi: 'Yangi',
    hujjat_yigilmoqda: "Hujjat yig'ilmoqda",
    hujjatlar_tayyor: 'Hujjatlar tayyor',
    viza_kutilmoqda: 'Viza kutilmoqda',
    viza_oldi: 'Viza oldi',
    jonatildi: "Jo'natildi",
    bekor: 'Bekor qilingan',
  },

  clientDetail: {
    qoshimchaTelefonlar: "Qo'shimcha telefonlar",
    zagranHolati: 'Pasport: toza / pechat bor',
    zagranBelgilanmagan: 'Belgilanmagan',
    zagranToza: "Toza (pechat yo'q)",
    zagranPechatBor: 'Pechat bor',
    readyToApply: "Hujjatda topildi: {value} — bosing, maydonga yoziladi",
    readyHint: "Yashil teglar hujjatda allaqachon topilgan — bosing, maydonga yoziladi ({n} ta).",
    // Teg yonidagi manba: qiymat qayerdan kelgani. AI — `ai_tekshir` (ikki
    // o'qish + kod tekshiruvi), OCR — Tesseract, MRZ ✓ — nazorat raqami bilan.
    factSource: { mrz: 'MRZ', ai: 'AI', ocr: 'OCR', text: 'matn', pdf_form: 'forma', manual: "qo'lda", anketa: 'anketa', xodim: 'xodim', claude: 'Claude', hujjat: 'hujjat', import: 'import' },
    factDocs: '{n} ta hujjatda bir xil',
    factConflict: "Hujjatlarda {n} xil qiymat — to'g'risini tanlang (sariq teglar)",
    factAlternative: '{source}: {value} — bosing, shu qiymat yoziladi',
    // Avtomatik yozilgan maydon manbasi va ishonch darajasi (clients/ishonch.py).
    fieldSource: {
      confirm: 'Tasdiqlash',
      levels: { tasdiqlangan: 'tasdiqlangan', yuqori: 'yuqori', orta: "o'rta", past: 'past' },
      tooltip: '{source} · ishonch: {level}',
      document: 'Hujjat: {doc}',
      holat: {
        savatda: "Manba hujjat savatda — mijoz kartasidagi «Savat» dan qaytarish mumkin",
        ochirilgan: "Manba hujjat butunlay o'chirilgan — qiymat xodim tasdig'i bilan qolgan",
      },
      belgi: { savatda: 'savatda', ochirilgan: "manba o'chirilgan" },
      confirmedBy: 'Tasdiqlagan: {who}',
      reviewHint: "To'g'ri bo'lsa ✓ bosing, xato bo'lsa qiymat ustiga bosib tahrirlang",
      reviewTitle: "Avtomatik to'ldirildi — tekshiring",
      reviewIntro: "Bu qiymatlar hujjatlardan o'zi yozildi. To'g'ri bo'lsa ✓ bosing, xato bo'lsa tahrirlang yoki hujjatdagi boshqa qiymatni tanlang.",
      confirmed: '{n} ta maydon tasdiqlandi',
      confirmHigh: 'Yuqori ishonchlilarni tasdiqlash ({n})',
      alternative: "Hujjatda boshqa qiymat: {value} ({source}) — bosing, shu yoziladi",
      alternativesLabel: 'Boshqa qiymatlar:',
    },
    zagranPassport: 'Zagran pasport',
    nationalPassport: 'Oddiy pasport / ID karta',
    zagranSeriesHint: 'FA',
    nationalSeriesHint: 'AD',
    nationalNumberHint: 'AD2098993',
    notFoundYet: "Hali topilmadi",
    notFoundHint: "Sariq — hujjatdan topilishi kerak edi, lekin topilmadi. Kulrang — buni o'zingiz yozasiz. Ustiga bosing va to'ldiring.",
    showFull: "To'liq ma'lumotini ko'rish",
    hideFull: "To'liq ma'lumotni yashirish",
    missing: 'Yetishmayapti:',
    andMore: '+ yana {n}',
    collection: "Hujjat yig'ish",
    ifNeeded: 'agar kerak',
    // Hisob ma'lumotlari (e-pochta, OneID) — parol shifrlangan
    credentials: "Hisob ma'lumotlari",
    credentialsHint: "Parollar shifrlangan holda saqlanadi. Parolni ko'rish jurnalga yoziladi: kim, qachon, qaysi mijoz.",
    credentialKeyMissing: "Shifrlash kaliti sozlanmagan — parol saqlash o'chirilgan. Administrator .env ga CREDENTIAL_KEY qo'shishi kerak.",
    addCredential: 'Hisob',
    noCredentials: "Hisob ma'lumoti qo'shilmagan",
    credentialKind: 'Turi',
    credentialLogin: 'Login',
    credentialPassword: 'Parol',
    credentialNote: 'Izoh',
    credentialLoginPrompt: 'Login yoki e-pochta manzilini kiriting',
    credentialLoginRequired: "Login bo'sh bo'lmasligi kerak",
    deleteCredentialConfirm: "{login} hisobi o'chiriladi. Davom etamizmi?",
    credKindEmail: 'E-pochta',
    credKindOneId: 'OneID',
    credKindMyGov: 'MyGov',
    credKindEmbassy: 'Elchixona portali',
    credKindOther: 'Boshqa',
    showPassword: "Parolni ko'rsatish",
    hidePassword: 'Parolni yashirish',
    changePassword: "Parolni o'zgartirish",
    noPassword: "Parol yo'q",
    passwordPrompt: '{login} uchun yangi parol',
    passwordPlaceholder: "Bo'sh qoldirilsa parol olib tashlanadi",
    copy: 'Nusxalash',
    copied: 'Nusxalandi',
    copyFailed: 'Nusxalanmadi',
    // Hujjatdan olinadigan shaxsiy ma'lumot (0019) va viza anketalari
    identityInfo: "Shaxsiy ma'lumotlar",
    middleName: 'Otasining ismi',
    gender: 'Jinsi',
    genderMale: 'Erkak',
    genderFemale: 'Ayol',
    genderUnspecified: "Ko'rsatilmagan",
    pinfl: 'JSHSHIR (PINFL)',
    pinflHint: '14 raqam',
    birthPlace: "Tug'ilgan joyi",
    birthDistrict: "Tug'ilgan tumani",
    email: 'E-pochta',
    passportSeries: 'Seriya',
    passportSeriesHint: 'AD',
    passportNumberHint: 'AD2098993',
    savedOk: 'Saqlandi',
    applications: 'Viza anketalari',
    addApplication: 'Anketa',
    noApplications: "Anketa qo'shilmagan",
    applicationNumber: 'Anketa raqami',
    applicationDate: 'Sanasi',
    applicationCountry: 'Davlat',
    applicationVisaType: 'Viza turi',
    applicationStatus: 'Holati',
    applicationNumberPrompt: 'Anketa raqamini kiriting',
    applicationNumberRequired: "Raqam bo'sh bo'lmasligi kerak",
    appStatusSubmitted: 'Topshirildi',
    appStatusWaiting: 'Kutilmoqda',
    appStatusAccepted: 'Qabul qilindi',
    appStatusRejected: 'Rad etildi',
    deleteApplicationConfirm: "{number} raqamli anketa o'chiriladi. Davom etamizmi?",
    title: "Client Ma'lumotlari",
    downloadAll: 'Yuklab olish',
    firstName: 'Ism',
    lastName: 'Familiya',
    dateOfBirth: "Tug'ilgan sana",
    passportNumber: 'Passport raqami',
    nationality: 'Fuqaroligi',
    issueDate: 'Berilgan sana',
    expiryDate: 'Amal qilish muddati',
    issuedBy: 'Kim tomonidan berilgan',
    issuedByHint: 'Masalan: MIA 26001 / IIV 26001',
    // 13.10: Control Center anketasi yozgan mijoz bilimi (ClientAnswer)
    anketaData: {
      employerTitle: 'Hozirgi ish joyi (yashash davlatida) — anketa 6/13',
      viewAll: 'Barchasi',
      formHint: "Anketa sahifalari tartibida HAMMA so'raladigan ma'lumot. Qizil — yetishmaydi: shu yerda to'ldiring — anketachi run davomida savol bermaydi.",
      progress: "Majburiy ma'lumot: {tayyor} / {jami} tayyor",
      notNeeded: 'kerak emas',
      title: "Anketa ma'lumotlari",
      hint: "Viza anketasi uchun yig'ilgan ma'lumot (ish beruvchi, manzil, safar). Qiymat ustiga bosib tahrirlang — anketa keyingi safar shu qiymatni oladi.",
      refresh: 'Yangilash',
      loadError: "Anketa ma'lumotlari yuklanmadi — tahrir yopiq",
      conflict: "Qiymat oraliqda o'zgargan — sahifani yangilab, qayta tasdiqlang",
    },
    country: 'Davlat',
    travelPurpose: 'Safar maqsadi',
    direction: "Yo'nalish",
    status: 'Status',
    jobTitle: 'Qanday ishga',
    employerName: 'Ish beruvchi',
    phone: 'Telefon',
    address: 'Manzil',
    notes: 'Izohlar',
    registeredBy: "Ro'yxatdan o'tkazgan",
    updatedAt: 'Yangilangan sana',
    createdAt: 'Yaratilgan sana',
    createCv: 'CV yaratish',
    lastModifiedBy: "Oxirgi o'zgartirgan",
    passportImage: 'Passport rasmi',
    universityName: 'OTM nomi',
    studyProgram: "O'qish dasturi",
    travelDates: 'Sayohat sanalari',
    hotelName: 'Mehmonxona',
    destinationCountry: 'Qaysi davlatga',
    personalInfo: "Shaxsiy ma'lumotlar",
    directionInfo: "Yo'nalish ma'lumotlari",
    passportInfo: "Passport ma'lumotlari",
    passportOptional: "Passport ma'lumotlari (ixtiyoriy)",
    statusChanged: 'Status o\'zgartirildi',
    statusChangeError: 'Status o\'zgartirishda xatolik',
    workDirection: 'Ish',
    studyDirection: "O'qish",
    travelDirection: 'Sayohat',
    businessDirection: 'Biznes',
    fullView: "To'liq ko'rish",
    updateSuccess: "Client ma'lumotlari yangilandi",
    updateError: "Ma'lumotlarni yangilashda xatolik",
    notFound: 'Client topilmadi',
    loadError: "Client topilmadi yoki yuklashda xatolik",
    noId: 'Client ID topilmadi',
    documents: 'Hujjatlar',
    selectDocType: 'Hujjat turini tanlang',
    selectFile: 'Fayl tanlang',
    uploadHint: 'Ruxsatli formatlar: PDF, JPG, PNG, GIF, DOC, DOCX, XLS, XLSX, PPT, PPTX, MP4, AVI, MOV (max 100MB)',
    uploadSuccess: 'Hujjat muvaffaqiyatli yuklandi!',
    uploadError: 'Hujjat yuklashda xatolik',
    noDocuments: "Hujjat yo'q",
    confirmDeleteDoc: "Hujjat savatga tushadi — fayli va o'qilgan ma'lumotlari saqlanadi, «Savat» dan qaytarish mumkin. Sabab (ixtiyoriy):",
    docDeleteSuccess: "Hujjat savatga tushdi — «Savat» dan qaytarish mumkin",
    deleteDocSabab: "Masalan: xato yuklangan, eski nusxa",
    savatgaTashlash: "Savatga tashlash",
    docDeleteError: "Hujjatni o'chirishda xatolik",
    downloadError: 'Yuklab olishda xatolik',
    fileSizeError: 'Fayl hajmi 100MB dan oshmasligi kerak',
    additionalNotes: "Qo'shimcha izohlar",
    showMore: "Ko'proq ko'rsatish",
    showLess: 'Kamroq',
    moreFiles: 'ta fayl',
    prevDoc: 'Oldingi',
    nextDoc: 'Keyingi',
    previewNotAvailable: "Bu turdagi faylni ko'rib bo'lmaydi. Yuklab oling.",
    videoNotSupported: "Brauzeringiz video formatini qo'llab-quvvatlamaydi",
    docs: {
      addMore: '+ Yana yuklash',
      filesSelected: '{n} ta fayl tanlandi',
      nUploaded: '{n} ta fayl yuklandi',
      badFile: "{fayl}: bu turdagi fayl qabul qilinmaydi",
      tooLarge: '{fayl}: {mb} MB dan katta',
      multiHint: "Bir nechta faylni birdaniga tanlash yoki sudrab tashlash mumkin. PDF, JPG, PNG, DOC(X), XLS(X), PPT(X) — 50 MB gacha. Video (300 MB gacha) o'zi «Video rolik» bo'limiga tushadi",
      variantName: 'CV varianti',
      variantPrompt: "{fayl} — bu CV variantini qanday nomlaymiz? (masalan: lavozim va til)",
      variantPlaceholder: "masalan: Payvandchi — inglizcha",
      turniTasdiqla: 'Turini tasdiqlash: {tur}',
      turTasdiqlangan: 'Tur tasdiqlangan',
      topshiriladi: 'Topshiriladi',
      topshirilmaydi: 'Topshirilmaydi',
      topshirishYoq: 'Belgilanmagan',
      topshirishBelgila: 'Topshirilsinmi?',
      topshirishOlib: 'Belgini olib tashlash',
      topshirishHint: "Elchixonaga topshiriladimi — bosib belgilang",
      topshirishKim: 'Belgiladi: {kim}, {vaqt}',
      topshirishFiltrHint: "Elchixona papkasiga kiradigan hujjatlar",
      topshirilmaydiSabab: "Nega topshirilmaydi? (ixtiyoriy)",
      topshirilmaydiMisol: "masalan: faqat ma'lumot uchun",
      izohUzun: "300 belgidan oshmasin",
      turTasdiqKim: "Tasdiqladi: {kim}, {vaqt}. Bosilsa — tasdiq olib tashlanadi",
      turTasdiqlandi: "Hujjat turi tasdiqlandi — anketa endi unga tayanadi",
      turTasdiqOlindi: "Tur tasdig'i olib tashlandi",
      nomTitle: 'Hujjat nomi',
      nomPrompt: "{fayl} — bu qanday hujjat? Nomini yozing: fayl shu nom bilan saqlanadi.",
      nomPromptQayta: "Hujjat nomini yozing: fayl shu nom bilan qayta nomlanadi.",
      nomPlaceholder: 'masalan: Harbiy guvohnoma',
      nomBosh: 'Hujjat nomini yozing',
      nomUzun: "Nom 200 belgidan oshmasin",
      nomBer: 'Nom berish',
      nomOzgartir: "Nomini o'zgartirish",
      nomSaqlandi: 'Nom saqlandi',
      faqatVideo: "{fayl}: «Video rolik» bo'limiga faqat video fayl yuklanadi (mp4, mov ...)",
      videogaOtdi: "{n} ta video «Video rolik» bo'limiga yuklandi",
      videoOqilmaydi: "Video — o'qilmaydi",
      filterAll: 'Hammasi',
      filterDone: "O'qildi",
      filterQueue: 'Navbatda',
      filterAttention: "E'tibor talab",
      queueHint: "Navbatda turgan yoki hozir o'qilayotgan hujjatlar",
      attentionHint: "O'qib bo'lmagan, boshqa odamniki / egasi aniqlanmagan yoki to'liq o'qilmagan hujjatlar",
      searchPlaceholder: "Fayl nomi yoki turi bo'yicha qidirish",
      dropTitle: 'Faylni shu yerga tashlang',
      dropOr: 'yoki',
      dropBrowse: 'kompyuterdan tanlang',
      dropActive: "Faylni qo'yib yuboring",
      typeRequired: 'Yuklash uchun hujjat turini tanlang',
      colDocument: 'Hujjat',
      colStatus: "O'qilish holati",
      colUploaded: 'Yuklangan',
      noMatch: "Bu filtrda hujjat yo'q",
      resetFilter: 'Filtrni tozalash',
      showMoreN: "Yana {n} ta hujjatni ko'rsatish",
    },
    // Hujjat o'qilish holati (OASIS / CEO PC)
    aylantir: {
      chapga: 'Chapga burish',
      ongga: "O'ngga burish",
      asl: 'Asl holiga',
      aslHint: "Hujjat yuklangandagi holatiga qaytadi (asl nusxa saqlangan)",
      saqlanmoqda: 'Saqlanmoqda…',
      ok: 'Hujjat aylantirildi',
      okAsl: 'Hujjat asl holiga qaytdi',
      okQayta: "Hujjat aylantirildi va qayta o'qishga yuborildi",
      xato: "Aylantirib bo'lmadi",
    },
    extraction: {
      orqaTomon: 'Orqa tomoni?',
      orqaTomonHint: "ID kartaning orqa tomoni yuklanmaganga o'xshaydi: JShShIR va tug'ilgan joy o'sha yerda. Orqa tomonini ham yuklang («+ Yana yuklash»).",
      mijozHozir: "Hozir o'qish",
      mijozHozirHint: "Bu mijoz eng muhim: hujjatlari navbat boshiga. O'qilmagan va kerakli ma'lumoti chiqmagan hujjatlar qayta o'qiladi",
      mijozHozirOk: "{u} ta hujjat navbat boshiga, {q} tasi qayta o'qishga yuborildi",
      mijozHozirNavbatda: "Hujjatlar allaqachon navbat boshida ({n} ta)",
      mijozHozirToliq: "Barcha hujjatlar o'qilgan, kerakli ma'lumotlar olingan",
      agentShu: "Hujjatchi agent hozir shu mijozning hujjatlarini o'qiyapti",
      agentBoshqa: "Hujjatchi agent boshqa mijozni o'qiyapti — tugashi bilan shu mijozga o'tadi",
      agentTayyor: "Hujjatchi agent tayyor — bir necha soniyada boshlaydi",
      agentUzilgan: "Hujjatchi agent {m} daqiqadan beri ulanmagan — agent kompyuteri yoqilgani va internetni tekshiring",
      agentYoq: "Hujjatchi agent ulanmagan — agent kompyuteri yoqilganini tekshiring",
      oqish: "Hujjatchi agent o'qisinmi",
      oqishYorliq: "O'qish",
      oqishOn: "Hujjatchi agent o'qiydi. O'chirsangiz — navbatdan chiqadi (o'qilgan ma'lumot saqlanadi)",
      oqishOnForced: "Xodim yoqgan: bu tur odatda o'qilmaydi, lekin o'qiladi",
      oqishOff: "O'qilmaydi — xodim o'chirgan. Yoqsangiz navbatga tushadi",
      oqishOffAuto: "Bu tur odatda o'qilmaydi (bazada borligi yetarli). Yoqsangiz o'qiladi",
      oqishYoqildi: "O'qish yoqildi",
      oqishOchirildi: "O'qish o'chirildi — hujjat navbatdan chiqdi",
      hozir: "Hozir o'qish",
      hozirHint: "Navbatning boshiga — hujjatchi agent keyingi aylanishda birinchi bo'lib shuni o'qiydi",
      hozirOk: "Navbat boshiga qo'yildi",
      orin: "{n}-o'rin",
      // Faktni mijoz maydoniga yozish
      applyToField: "Mijoz maydoniga yozish",
      appliedTo: "{field} maydoniga yozildi",
      notApplied: "Yozilmadi",
      ownerFamily: "Oila a'zosi #{n}",
      ownerFamilyPlain: "Oila a'zosi",
      ownerForeign: 'Begona odam',
      ownerUnknown: "Egasi noma'lum",
      summary: "O'qildi {done}/{total}",
      summaryHint: "OASIS (CEO PC) o'qib, ma'lumotini bazaga qo'shgan hujjatlar soni",
      doneCount: "O'qildi · {n} ma'lumot",
      pending: 'Navbatda',
      processing: "O'qilmoqda",
      failed: 'Xato',
      skipped: "O'qilmaydi",
      opusKutadi: 'Opus tekshiruvini kutmoqda',
      opusKutadiHint: "Qo'lyozma hujjat: qoida bilan (OCR / MRZ) o'qilmaydi — Opus tekshiruvchi iqtibos bilan o'qiydi",
      opusOdam: "Opus o'qiy olmadi — odam o'qisin",
      opusIshYoq: "Opus o'qidi — ish yozuvi yo'q",
      unknown: "Holat yo'q",
      pendingHint: "Hali o'qilmagan — CEO PC navbatida",
      processingHint: "CEO PC hozir o'qiyapti",
      failedHint: "O'qib bo'lmadi: {error}",
      skippedHint: "Bu turdagi hujjatdan ma'lumot olinmaydi",
      skippedReasonHint: "O'qilmadi: {error}",
      unknownHint: "O'qilish holati yozilmagan",
      factsTitle: "Hujjatdan olingan ma'lumotlar",
      doneOf: "O'qildi · {olindi}/{jami}",
      expectedTitle: "Kutilgan ma'lumotlar",
      notExtracted: 'Olinmadi',
      humanReads: 'Xodim hujjatdan kiritadi',
      presenceOnly: "Bu hujjatdan ma'lumot o'qilmaydi — bazada borligi yetarli",
      openFactsHint: "Bosing — hujjat va undan olingan ma'lumotlar yonma-yon ochiladi",
      noFacts: "Hujjatdan ma'lumot topilmadi",
      notReadYet: "Hujjat hali o'qilmagan",
      verified: 'Tasdiqlangan (MRZ / nazorat raqami)',
      unverified: 'Tasdiqlanmagan — tekshirib chiqing',
      loadError: "Ma'lumotlarni yuklab bo'lmadi",
      reprocess: "Qayta tekshirishga yuborish",
      reprocessShort: "Qayta tekshirish",
      autoApplied: "Kartaga avtomatik yozildi: {fields}",
      reprocessConfirm: "Hujjat qayta tekshiriladi, hozir olingan ma'lumotlar o'chadi. Sababini yozing (ixtiyoriy):",
      reprocessQueued: "Hujjat qayta o'qish navbatiga qo'yildi",
      reprocessError: "Qayta o'qishga qo'yib bo'lmadi",
      reprocessPrompt: "Hujjat qayta tekshiriladi. Sababini yozing (ixtiyoriy):",
      reprocessReasonPlaceholder: "Masalan: familiya xato chiqqan",
      reviewInfo: "Qayta tekshirishga yuborgan: {user}, {date}",
      foreignSummary: "{n} ta hujjat boshqa odamniki",
      foreignSummaryHint: "Bu hujjatlar boshqa odamga tegishli ko'rinadi — adashib yuklanmaganini tekshiring",
      docOwnerForeign: "Boshqa odamniki",
      docOwnerUnknown: "Egasi aniqlanmadi",
      docOwnerFamily: "Oila a'zosiniki",
    },

    firstNameRequired: 'Ismni kiriting',
    lastNameRequired: 'Familiyani kiriting',
    passportRequired: 'Passport raqamini kiriting',
    birthDateRequired: "Tug'ilgan sanani tanlang",
    issueDateRequired: 'Berilgan sanani tanlang',
    expiryDateRequired: 'Amal qilish muddatini tanlang',
    countryRequired: 'Davlatni kiriting',
    phoneRequired: 'Telefon raqamini kiriting',
    addressRequired: 'Manzilni kiriting',
    vacLinkedSuccess: '{count} ta vakansiya biriktirildi',
    vacUnlinkedSuccess: 'Vakansiya olib tashlandi',
    employeesAssigned: 'Xodimlar biriktirildi',
    employeeAssigned: 'Hodim biriktirildi',
    assignCancelled: 'Biriktirish bekor qilindi',
    fileTooLarge: 'Fayl hajmi 100MB dan oshmasligi kerak',
    errorGeneric: 'Xatolik yuz berdi',
  },

  docTypes: {
    oddiy_pasport: 'Passport oddiy',
    zagran_pasport: 'Passport zagran',
    bank_schyot: 'Bank statement',
    ish_staji: 'Ishxona',
    ishxona_tarjima: 'Ishxona tarjima',
    mygov_digital: 'Digital information (my.gov)',
    mygov_family: 'Family information (my.gov)',
    mygov_yashash: 'Yashash joyidan ma’lumotnoma (my.gov)',
    anketa: 'Anketa',
    explanation_letter: 'Explanation letter',
    hotel_booking: 'Hotel booking',
    bron_bilet: 'Avia booking',
    priglosheniye: 'Invitation letter',
    diplom: 'Diplom',
    til_sertifikat: 'Til sertifikat',
    trip_plan: 'Trip plan',
    sudlanmaganlik: 'Sudlanmaganlik',
    sudlanmaganlik_tarjima: 'Sudlanmaganlik tarjimasi',
    mol_mulk: 'Mol-mulk',
    mol_mulk_tarjima: 'Mol-mulk tarjima',
    sugurta: "Sug'urta",
    cv_photo: 'Rasm',
    cv: 'CV',
    qoshimcha: "Qo'shimcha hujjatlar",
    video: 'Video rolik',
    patent: 'Ish patenti (Rossiya)',
    nikoh_guvohnoma: 'Nikoh guvohnomasi',
  },

  clientCreate: {
    title: 'Yangi client yaratish',
    step1Title: "Passport va asosiy ma'lumotlar",
    step2Title: "Yo'nalish tanlash",
    whichRegion: "Qaysi mintaqaga",
    whichCountry: "Qaysi davlatga",
    selectCountryOptional: "Davlat tanlang (ixtiyoriy)",
    peopleCount: "Kishilar soni",
    uploadPassportText: "Passport rasmini yuklang <em>yoki bu yerga tashlang</em>",
    uploadPassportTip: "JPG/PNG formatda passport rasmi. OCR avtomatik ma'lumotlarni aniqlaydi.",
    dividerBasic: "Asosiy ma'lumotlar",
    dividerPassport: "Passport ma'lumotlari",
    dividerPassportFull: "Passport ma'lumotlari",
    regionEurope: 'Yevropa',
    regionAsia: 'Osiyo',
    regionAmerica: 'Amerika',
    regionOther: 'Boshqa',
    person1: '1 kishi',
    person2: '2 kishi',
    personFamily: 'Oilaviy',
    personGroup: 'Guruh',
    personOther: 'Boshqa',
    step3Title: 'Passport (ixtiyoriy)',
    step1: 'Passport yuklash',
    step2: "Ma'lumotlarni tahrirlash",
    step3: "Qo'shimcha ma'lumotlar",
    step4: 'Hujjatlar yuklash',
    firstName: 'Ism',
    lastName: 'Familiya',
    directionSelect: "Yo'nalishni tanlang",
    saveWithoutPassport: 'Passportsiz saqlash',
    universityName: 'OTM nomi',
    studyProgram: "O'qish dasturi",
    travelDates: 'Sayohat sanalari',
    hotelName: 'Mehmonxona',
    passportUploadDrag: 'Passport rasmini shu yerga tashlang yoki',
    passportUploadClick: 'bosing',
    passportUploadHint: 'JPG, JPEG yoki PNG format, max 10MB',
    processOcr: 'Qayta ishlash (OCR)',
    ocrProcessing: 'OCR qayta ishlash...',
    ocrDialogTitle: 'OCR Natijasi',
    ocrExtractedData: 'Ajratilgan ma\'lumotlar',
    ocrRawText: 'Xom matn',
    ocrNoText: "Matn topilmadi",
    ocrClose: 'Yopish',
    ocrContinue: 'Davom etish',
    ocrSuccess: 'Passport muvaffaqiyatli qayta ishlandi',
    ocrError: 'OCR qayta ishlashda xatolik',
    ocrNotFound: "Passport ma'lumotlari topilmadi",
    ocrParseError: "Ma'lumotlarni tahlil qilishda xatolik",
    destinationCountry: 'Qaysi davlatga',
    travelPurpose: 'Safar maqsadi',
    jobTitle: 'Qanday ishga',
    employerName: 'Ish beruvchi nomi',
    phone: 'Telefon',
    address: 'Manzil',
    additionalNotes: "Qo'shimcha izohlar",
    clientCreatedSuccess: 'Client muvaffaqiyatli yaratildi!',
    uploadDocuments: 'Hujjatlarni yuklang',
    done: 'Tugatish',
    createError: 'Client yaratishda xatolik',
    firstNameRequired: 'Ismni kiriting',
    lastNameRequired: 'Familiyani kiriting',
    passportRequired: 'Passport raqamini kiriting',
    birthDateRequired: "Tug'ilgan sanani tanlang",
    issueDateRequired: 'Berilgan sanani tanlang',
    expiryDateRequired: 'Amal qilish muddatini tanlang',
    countryRequired: 'Davlatni kiriting',
    phoneRequired: 'Telefon raqamini kiriting',
    addressRequired: 'Manzilni kiriting',
    placeholderFirstName: 'Masalan: SHERZOD',
    placeholderLastName: 'Masalan: XOTAMOV',
    placeholderAddress: 'Shahar, tuman',
    placeholderNotes: "Qo'shimcha ma'lumotlar...",
    placeholderCountry: 'Masalan: Germaniya',
    placeholderJobTitle: 'Masalan: Qurilishchi',
    placeholderEmployer: 'Kompaniya nomi',
    placeholderUniversity: 'Universitet nomi',
    placeholderProgram: 'Masalan: IT, Tibbiyot',
    placeholderTravelDates: 'Masalan: 15.06 - 30.06',
    placeholderHotel: 'Mehmonxona nomi',
    placeholderPassportNumber: 'Masalan: AD2098993',
    placeholderPosition: 'Lavozim yoki maqsad',
    dividerWorkInfo: "Ish ma'lumotlari",
    dividerStudyInfo: "O'qish ma'lumotlari",
    dividerTravelInfo: "Sayohat ma'lumotlari",
    dividerBusinessInfo: "Biznes ma'lumotlari",
    passportOptionalNote: 'Passportsiz ham client yaratish mumkin',
    ocrResultsTitle: 'OCR natijalari',
    detectedData: "Aniqlangan ma'lumotlar",
    verifyImage: 'Rasm bilan solishtiring',
    clickToEnlarge: 'Kattalashtirish uchun bosing',
    applyOcr: "Qo'llash va to'ldirish",
    editIfWrong: "✎ Noto'g'ri bo'lsa tahrirlang",
    manualSection: "Qo'lda kiritiladi",
    manualSectionSub: "Bu maydonlar OCR orqali aniqlanmaydi — hodim o'zi kiritadi",
    duplicateTitle: 'Mijoz allaqachon mavjud',
    duplicateMsg: 'Bu passport raqami bilan mijoz ({name}) tizimda ro\'yxatdan o\'tgan. Ochmoqchimisiz?',
    openExisting: 'Ochish',
    alreadyExistsShort: 'Bu passport raqami bilan mijoz allaqachon mavjud',
  },

  vacancies: {
    title: 'Vakansiyalar',
    totalVacancies: 'Jami vakansiyalar',
    active: 'Faol',
    closed: 'Yopiq',
    draft: 'Loyiha',
    searchPlaceholder: 'Vakansiya, kompaniya, shahar...',
    jobType: 'Ish turi',
    experience: 'Tajriba',
    statusFilter: 'Holat',
    newVacancy: 'Yangi vakansiya',
    editVacancy: 'Vakansiya tahrirlash',
    vacancyName: 'Vakansiya nomi',
    company: 'Kompaniya',
    city: 'Shahar',
    country: 'Davlat',
    description: 'Tavsif',
    salaryMin: 'Ish haqi (min)',
    salaryMax: 'Ish haqi (max)',
    currency: 'Valyuta',
    status: 'Holat',
    deadline: 'Oxirgi sana',
    deadlineLabel: 'Oxirggi sana',
    fullTime: "To'liq vaqt",
    partTime: 'Yarim vaqt',
    contract: 'Shartnama',
    temporary: 'Vaqtinchalik',
    noExperience: 'Tajriba kerak emas',
    junior: 'Kichik (0-2 yil)',
    mid: "O'rta (2-5 yil)",
    senior: 'Senior (5+ yil)',
    draftStatus: 'Loyiha',
    activeStatus: 'Faol',
    closedStatus: 'Yopiq',
    uzs: "So'm (UZS)",
    usd: 'Dollar (USD)',
    eur: 'Yevro (EUR)',
    rub: 'Rubl (RUB)',
    confirmDelete: "vakansiyasini o'chirmoqchisiz?",
    deleteSuccess: "Vakansiya o'chirildi",
    updateSuccess: 'Vakansiya yangilandi',
    createSuccess: 'Vakansiya yaratildi',
    formError: 'Xatolik yuzaga keldi',
    notFound: 'Vakansiya topilmadi',
    nameRequired: 'Vakansiya nomi kiriting',
    companyRequired: 'Kompaniya nomi kiriting',
    cityRequired: 'Shahar kiriting',
    countryRequired: 'Davlat kiriting',
    descriptionRequired: 'Tavsif kiriting',
    descriptionPlaceholder: "Vakansiya to'risida batafsilat...",
  },

  scraped: {
    copyPhone: 'Raqamdan nusxa olish',
    phoneCopied: 'Nusxa olindi: {phone}',
    copyFailed: 'Nusxa olib bo‘lmadi',
    bulkDeleteBtn: "O'chirish",
    title: 'Scrape Vakansiyalar',
    total: 'Jami',
    unchecked: 'Tekshirilmagan',
    agency: 'Agentstvo',
    direct: "To'g'ridan-to'g'ri",
    scammer: 'Mashenik',
    allFilter: 'Barchasi',
    calledFilter: 'Telefon qilingan',
    categoryFilter: 'Kategoriya',
    noAnswer: "Ko'tarmadi",
    callback: "Qayta qo'ng'iroq qil dedi",
    callError: 'Statusni yangilashda xato',
    countryFilter: 'Davlat',
    siteFilter: 'Sayt',
    scrapeBtn: '1. Scrape',
    filterBtn: '2. Filter',
    detailBtn: '3. Detail',
    uploadBtn: '4. Upload',
    importJson: 'Import JSON',
    clearBtn: 'Tozalash',
    jobTitle: 'Vakansiya nomi',
    postedDate: 'Sana',
    country: 'Davlat',
    direction: "Yo'nalish",
    phoneNumber: 'Telefon',
    email: 'Email',
    phoneCall: 'Telefon',
    category: 'Toifa',
    unassigned: 'Biriktirilmagan',
    remoteTag: 'Remote',
    expiredTag: 'Eskirgan',
    partnerNew: 'Hamkor',
    partnerRegular: 'Doimiy',
    partnerPremium: 'VIP',
    ctAgency: 'Agentlik',
    ctDirect: "To'g'ridan",
    ctScammer: 'Firibgar',
    ctUnknown: "Noma'lum",
    ctOpen: 'Ochiq',
    dirWork: 'Ish',
    dirStudy: "Ta'lim",
    dirTravel: 'Sayohat',
    dirAvia: 'Avia',
    subWarehouse: 'Sklad',
    subFactory: 'Ishlab chiq.',
    subFarm: 'Ferma',
    subBuild: 'Qurilish',
    subIt: 'IT',
    subOther: 'Umumiy',
    expired: 'Muddati tugagan',
    selectEmployees: 'Xodimlarni tanlang',
    removeAssignees: 'Xodimlarni olib tashlash',
    assignBtn: 'Biriktirish',
    makeOpen: 'Ochiq qilish',
    viewOnlyBanner: "Bu vakansiya {name} ga biriktirilgan. Faqat ko'rish rejimi.",
    contactLabel: 'Kontakt',
    phoneLabel: 'Telefon',
    phonesLabel: 'Telefonlar',
    emailLabel: 'Email',
    emailsLabel: 'Emaillar',
    telegramLabel: 'Telegram',
    whatsappLabel: 'WhatsApp',
    openSource: "Asl e'lonni ochish",
    newVacanciesAlert: "{n} ta yangi vakansiya shu korxonadan e'lon qilingan!",
    otherVacancies: 'Shu kontaktning boshqa vakansiyalari ({n})',
    newTag: 'YANGI',
    callsCount: "{n} qo'ng'iroq",
    callBtn: "Qo'ng'iroq",
    emailBtn: 'Email',
    callAnswered: 'Javob berdi',
    callNoAnswer: "Ko'tarmadi",
    callCallback: "Qayta qo'ng'iroq",
    writeNotePh: 'Izoh yozing...',
    selectCategory: 'Toifani belgilang',
    saveBtn: 'Saqlash',
    filterAll2: 'Hammasi',
    filterCallback: 'Qayta',
    searchByNotePh: "Izoh bo'yicha qidirish...",
    noNoteWritten: 'Izoh yozilmagan',
    noCallsYet: "Hali qo'ng'iroqlar yo'q",
    callsTab: "Qo'ng'iroqlar",
    linkedClientsTab: 'Biriktirilgan mijozlar',
    addClientBtn: "+ Mijoz qo'shish",
    noLinkedClients: "Biriktirilgan mijozlar yo'q",
    unlinkClient: 'Olib tashlash',
    selectClientDialog: 'Mijoz tanlash',
    clientSearchPh: 'Ism, telefon, passport...',
    refreshTip: 'Yangilash',
    totalClients: 'Jami: {n} mijoz · Ko\'rsatilgan: {m}',
    notFoundShort: 'Topilmadi',
    noClientsYet: 'Mijoz mavjud emas',
    selectedSuffix: '{n} ta tanlangan',
    cancelBtn: 'Bekor',
    linkBtn: 'Biriktirish',
    ctDirect2: 'Ish beruvchi',
    ctAgency2: 'Agentlik',
    ctScammer2: 'Mashenik',
    ctUnknown2: 'Nomalum',
    qnAnswered1: "Gaplashildi, ma'lumot berdi",
    qnAnswered2: 'Hujjat tayyorlayapti',
    qnAnswered3: 'Kelishildi, kutilmoqda',
    qnAnswered4: 'Shartnoma muhokama qilindi',
    qnAnswered5: "Dokumentlar so'raldi",
    qnAnswered6: 'Boshqa vaqtga kelishildi',
    qnNoAns1: "Ko'tarmadi, javob bermadi",
    qnNoAns2: 'Nomer eskirgan / ishlamaydi',
    qnNoAns3: 'Nomer boshqaga tegishli',
    qnNoAns4: "Telefon o'chirilgan",
    qnNoAns5: "Qo'ng'iroqni rad etdi",
    qnNoAns6: 'Tarmoqdan tashqarida',
    qnCall1: 'Birozdan keyin qayta qil dedi',
    qnCall2: "Band, keyinroq qo'ng'iroq qiling dedi",
    qnCall3: 'Hozir gaplasha olmaydi',
    qnCall4: "Ikkinchi yo'nalishga tushdi",
    qnCall5: "Ish vaqtida qayta qo'ng'iroq",
    qnCall6: 'Boshqa agentlik bilan ishlayapti',
    notFound: 'Vakansiya topilmadi',
    process: 'Jarayon',
    running: 'Ishlayapti...',
    finished: 'Tugadi!',
    now: 'Hozir',
    stop: "To'xtatish",
    scrapeLabel: 'Scrape (9 ta sayt)',
    filterLabel: "Filter (kalit so'z bo'yicha)",
    detailLabel: 'Detail (telefon/email olish)',
    anotherRunning: 'Boshqa jarayon ishlayapti',
    scrapeError: 'Scrape ishga tushmadi',
    filterError: 'Filter ishga tushmadi',
    detailError: 'Detail ishga tushmadi',
    importSuccess: 'Import: {created} ta yangi, {skipped} ta duplikat',
    importError: 'Import xatosi',
    clearConfirm: "Telefon qilinmagan barcha ishlar o'chiriladi. Telefon qilinganlar saqlanib qoladi.",
    clearTitle: 'Bazani tozalash',
    stopRequested: "To'xtatish so'raldi — jarayon tez orada tugaydi",
    stopError: "To'xtatishda xatolik",
    saveError: 'Saqlashda xatolik',
    classifyError: 'Xatolik yuzaga keldi',
    callError: 'Xatolik yuzaga keldi',
    phonePlaceholder: '+371...',
    emailPlaceholder: 'email@...',
    filterAll: 'Hammasi',
    filterCalled: "Qo'ng'iroq qilingan",
    filterAssigned: 'Biriktirilgan',
    filterRecall: "Qayta qo'ng'iroq",
    directionPlaceholder: "Yo'nalish",
    jobTypePlaceholder: 'Kasb turi',
    detailsLoadError: 'Tafsilotlarni yuklashda xatolik',
    errorGeneric: 'Xatolik yuz berdi',
    vacancyReopened: 'Vakansiya ochiq qilindi',
    noteSaved: 'Izoh saqlandi',
    noteError: 'Izohni saqlashda xatolik',
    callLogError: "Qo'ng'iroqni qayd qilishda xatolik",
    partnerAlready: "Bu vakansiya allaqachon hamkorlar ro'yxatiga qo'shilgan",
    saved: 'Saqlandi',
    clientUnlinked: 'Mijoz olib tashlandi',
    markedAsPartner: 'Hamkor sifatida belgilandi',
    selectTime: 'Vaqtni tanlang',
    scheduleAdded: "Jadval qo'shildi",
    deleted: "O'chirildi",
  },

  users: {
    title: 'Xodimlar',
    newEmployee: 'Yangi xodim',
    username: 'Username',
    fullName: 'Ism Familiya',
    email: 'Email',
    phone: 'Telefon',
    role: 'Rol',
    status: 'Status',
    actions: 'Amallar',
    editTitle: 'Xodim tahrirlash',
    createTitle: 'Yangi xodim',
    firstName: 'Ism',
    lastName: 'Familiya',
    password: 'Parol',
    roleAdmin: 'Boshliq',
    roleEmployee: 'Xodim',
    activeStatus: 'Aktiv',
    inactiveStatus: 'Nofaol',
    editSuccess: 'Xodim yangilandi',
    createSuccess: 'Xodim yaratildi',
    saveError: 'Saqlashda xatolik',
    loadError: "Ma'lumot yuklashda xatolik",
    usernameRequired: 'Username kiriting',
    emailRequired: 'Email kiriting',
    firstNameRequired: 'Ism kiriting',
    lastNameRequired: 'Familiya kiriting',
    passwordRequired: 'Parol kiriting',
    passwordMinLength: 'Parol kamida 6 ta belgi',
    resetPassword: 'Parol tiklash',
    resetPasswordTitle: 'Parolni tiklash',
    resetPasswordHint: 'Yangi parol o\'rnating (eski parol talab qilinmaydi)',
    newPassword: 'Yangi parol',
    confirmPassword: 'Parolni tasdiqlang',
    newPasswordPlaceholder: 'Yangi parolni kiriting',
    confirmPasswordPlaceholder: 'Parolni qayta kiriting',
    newPasswordRequired: 'Yangi parolni kiriting',
    confirmPasswordRequired: 'Parolni tasdiqlang',
    passwordsNotMatch: 'Parollar mos kelmaydi',
    resetPasswordSuccess: 'Parol muvaffaqiyatli tiklandi!',
    resetPasswordError: 'Parol tiklashda xatolik',
  },

  profile: {
    title: 'Profil',
    username: 'Username',
    email: 'Email',
    firstName: 'Ism',
    lastName: 'Familiya',
    phone: 'Telefon',
    role: 'Rol',
    roleAdmin: 'Boshliq',
    roleEmployee: 'Xodim',
    changePassword: "Parolni o'zgartirish",
    changePasswordTitle: "Parolni o'zgartirish",
    oldPassword: 'Eski parol',
    newPassword: 'Yangi parol',
    confirmPassword: 'Parolni tasdiqlash',
    passwordsNotMatch: 'Parollar mos emas',
    oldPasswordRequired: 'Eski parolni kiriting',
    newPasswordRequired: 'Yangi parolni kiriting',
    newPasswordMinLength: 'Kamida 6 ta belgi',
    confirmPasswordRequired: 'Parolni tasdiqlang',
    passwordChanged: "Parol muvaffaqiyatli o'zgartirildi",
    passwordChangeError: "Parolni o'zgartirishda xatolik",
    adminResetHint: "Admin sifatida eski parolsiz o'zgartira olasiz",
    uploadAvatar: "Rasm yuklash",
    uploadAvatarSuccess: "Rasm muvaffaqiyatli yuklandi",
    uploadAvatarError: "Rasm yuklashda xatolik",
    avatarSizeError: "Rasm hajmi 20MB dan oshmasligi kerak",
    editProfile: "Profilni tahrirlash",
    saveProfile: "Saqlash",
    editSuccess: "Ma'lumotlar saqlandi",
    editError: "Saqlashda xatolik",
  },

  settings: {
    title: 'Sozlamalar',
    basePath: 'Fayllarga saqlash manzili',
    basePathPlaceholder: 'Masalan: /home/user/crm_files',
    save: 'Saqlash',
    hint: "Bu manzilga client hujjatlari saqlanadi. Bo'sh qoldirilsa MEDIA_ROOT ishlatiladi.",
    currentStructure: 'Hozirgi tuzilma',
    noSetting: "Sozlama belgilanmagan (default MEDIA_ROOT)",
    pathRequired: 'Manzil kiriting',
    saveSuccess: 'Sozlama saqlandi',
    saveError: 'Saqlashda xatolik',
  },

  cvBuilder: {
    title: 'CV Builder',
    back: 'Orqaga',
    cvBuild: 'CV Build',
    jobDetails: 'Vakansiya tafsilotlari',
    layoutSubtitle: 'CV joylashuv strukturasini tanlang',
    layout: 'Struktura',
    templateSubtitle: 'CV ranglar sxemasini tanlang',
    template: 'Rang shabloni',
    jobDetailPlaceholder: 'Vakansiya tavsifini shu yerga joylashtiring: lavozim, kompaniya, davlat, talablar...',
    selectClient: 'Client tanlang',
    searchClient: 'Client qidirish...',
    clientSearchResults: '{count} ta natija topildi',
    clientPageInfo: '{from}–{to} / jami {total}',
    fullName: 'Ism Familiya',
    passport: 'Passport',
    country: 'Davlat',
    phone: 'Telefon',
    selectedClient: 'Tanlangan client',
    buildCv: 'CV Yaratish',
    description: 'Tavsif',
    sourceLink: 'Manbaga havola',
    noJob: 'Vakansiya topilmadi',
    buildSuccess: 'CV muvaffaqiyatli yaratildi!',
    buildError: 'CV yaratishda xatolik',
    loadError: "Ma'lumotlarni yuklashda xatolik",
    jobTitle: 'Lavozim nomi',
    company: 'Kompaniya',
    city: 'Shahar',
    salary: 'Ish haqi',
    language: 'CV tili',
    jobTitlePlaceholder: 'Masalan: Oshpaz, Quruvchi...',
    companyPlaceholder: 'Kompaniya nomi',
    countryPlaceholder: 'Masalan: Germaniya',
    cityPlaceholder: 'Masalan: Berlin',
    salaryPlaceholder: 'Masalan: 1500 EUR',
    descriptionPlaceholder: 'Vakansiya tavsifi...',
    recommended: 'Tavsiya',
    previewTitle: 'CV Ko\'rinishi',
    previewHint: 'Matnga bosib tahrirlang. Rasmga bosing — uni yaqinlashtirish/uzoqlashtirish va siljitish paneli chiqadi. Barcha o\'zgarishlar PDF\'da saqlanadi.',
    save: 'Saqlash',
    saveAsPdf: 'PDF sifatida',
    saveAsDocx: 'Word (DOCX) sifatida',
    saveFormatTitle: 'Qaysi formatda saqlaysiz?',
    saveFormatPdfDesc: 'Tahrirlashlaringiz saqlanadi, professional ko\'rinish',
    saveFormatDocxDesc: 'Tahrirlashsiz original Word fayl',
    discard: 'Bekor qilish',
    discarded: 'CV bekor qilindi',
    prompts: 'Promptlar',
    newPrompt: 'Yangi prompt',
    editPrompt: 'Promptni tahrirlash',
    promptName: 'Prompt nomi',
    promptNamePlaceholder: 'Masalan: Standart CV prompt',
    promptContent: 'Prompt matni',
    promptChars: '{count} belgi',
    promptContentPlaceholder: 'CV yaratish uchun ko\'rsatmalarni yozing...',
    noPrompts: 'Hali prompt qo\'shilmagan',
    promptRequired: 'Nom va matn kiritilishi kerak',
    promptCreated: 'Prompt yaratildi',
    promptUpdated: 'Prompt yangilandi',
    promptDeleted: 'Prompt o\'chirildi',
    promptSaveError: 'Promptni saqlashda xatolik',
    promptDeleteError: 'Promptni o\'chirishda xatolik',
    photoTitle: 'CV rasm',
    uploadPhoto: 'Rasm yuklash',
    photoUploaded: 'Rasm yuklandi (shu CV uchun)',
    photoFromClient: 'Client profilidagi rasm ishlatiladi',
    photoNone: 'Rasm yo\'q',
    photoInvalid: 'Faqat rasm fayllari qo\'llab-quvvatlanadi',
    photoWarnForLayout: 'Tanlangan shablon rasmga tayyorlangan. Yaxshi natija uchun rasm yuklang.',
    reviewTitle: 'CV ma\'lumotlarini ko\'rib chiqing va tasdiqlang',
    reviewHint: 'AI yaratgan ma\'lumotlarni sinchkovlik bilan tekshiring. Xato bo\'lsa to\'g\'irlang. Tasdiqlagach PDF shaklida yaratiladi.',
    professionalTitle: 'Professional lavozim nomi',
    summary: 'Professional xulosa',
    experience: 'Ish tajribasi',
    position: 'Lavozim',
    employer: 'Ish beruvchi (kompaniya)',
    period: 'Davr',
    periodPlaceholder: 'Masalan: Sentabr 2018 – Iyun 2021',
    description: 'Tavsif',
    institution: 'O\'quv muassasasi',
    specialization: 'Mutaxassislik / Daraja',
    addExp: 'Tajriba qo\'shish',
    addEdu: 'Ta\'lim qo\'shish',
    addSkill: 'Ko\'nikma qo\'shish',
    addLanguage: 'Til qo\'shish',
    confirmAndGeneratePdf: 'Tasdiqlash va PDF yaratish',
    note: 'Izoh',
    education: 'Ta\'lim',
    skills: 'Ko\'nikmalar',
    languages: 'Tillar',
    enhanceWithAI: 'AI bilan yaxshilash',
    photoEnhanced: 'Rasm AI orqali yaxshilandi',
    clearVacancy: 'Tozalash',
    vacancySearchPlaceholder: 'Vakansiyani qidiring (nomi, davlat, kompaniya)...',
    layoutModernPhoto: 'Zamonaviy',
    layoutBadgeSidebar: 'Badge elegant',
    layoutTopHeader: 'Yuqori header',
    layoutSidebarLeft: 'Chap sidebar',
    layoutSidebarRight: "O'ng sidebar",
    layoutClassic: 'Klassik',
    imgZoomOut: 'Uzoqlashtirish',
    imgZoomIn: 'Yaqinlashtirish',
    imgPanLeft: 'Chapga',
    imgPanUp: 'Tepaga',
    imgPanDown: 'Pastga',
    imgPanRight: "O'ngga",
    imgReset: 'Qaytarish',
    imgClose: 'Yopish',
    aiFallbackWithError: 'AI fallback ishladi: {error}',
    aiFallbackPlain: 'AI ishlamadi, oddiy CV yaratildi',
    buildTimeout: "CV yaratish vaqti tugadi (timeout). Iltimos qayta urinib ko'ring.",
    docxEditsLostWarning: 'Word formati tahrirlashsiz original holatda saqlanadi. Tahrir saqlanishi uchun PDF tanlang.',
    clientAutoSelected: 'Klient avtomatik tanlandi: {name}',
    clientLoadFailed: "Klient yuklanmadi — qo'lda tanlang",
  },

  telefonlar: {
    qoshish: "+ Raqam qo'shish",
    tahrirlash: 'Tahrirlash',
    raqam_qoshish: "Raqam qo'shish",
    raqam: 'Raqam',
    namuna: '+998 90 123 45 67',
    olib_tashlash: 'Olib tashlash',
    maks: "Eng ko'pi {n} ta qo'shimcha raqam",
    nusxa: 'Nusxa olish',
    nusxalandi: 'Nusxa olindi',
  },
  educationEditor: {
    kiritilmagan: "Ta'lim kiritilmagan",
    qoshish: "+ Ta'lim qo'shish",
    tahrirlash: 'Tahrirlash',
    label: "Ta'lim",
    institutionLabel: 'O\'quv muassasasi',
    institutionPlaceholder: "Masalan: Toshkent Davlat Texnika Universiteti",
    specializationLabel: 'Mutaxassislik / Yo\'nalish',
    specializationPlaceholder: 'Masalan: Elektr muhandisligi',
    fromYear: 'Qaysi yildan',
    toYear: 'Qaysi yilgacha',
    present: 'Hozir',
    addMore: "Yana o'quv muassasasi qo'shish",
    hint: "Ixtiyoriy. Kiritilgan ta'lim CV'da saqlanadi, bo'sh bo'lsa AI o'zi yaratadi.",
    empty: "O'quv muassasasi qo'shilmagan — AI to'ldiradi.",
  },

  workExperience: {
    label: 'Ish tajribalari',
    placeLabel: 'Joy nomi',
    placePlaceholder: 'Masalan: TTZ Traktor Zavodi (Toshkent)',
    positionLabel: 'Lavozim',
    positionPlaceholder: 'Masalan: Elektropayvandchi, Quvurchi usta, Haydovchi...',
    fromYear: 'Qaysi yildan',
    toYear: 'Qaysi yilgacha',
    present: 'Hozir',
    addMore: 'Yana ish joyi qo\'shish',
    hint: 'Ixtiyoriy. Kiritilgan joylar CV\'da saqlanadi. Qolgan yillarni AI o\'zi to\'ldirib boyitadi.',
    empty: 'Ish joyi qo\'shilmagan — AI to\'liq tajribani o\'zi yaratadi.',
    errorFromGreater: 'Boshlangan yil tugagan yildan katta bo\'la olmaydi',
  },

  languageSelector: {
    label: 'Biladigan tillar',
    languagePlaceholder: 'Til',
    levelPlaceholder: 'Daraja',
    addMore: 'Yana til qo\'shish',
    hint: 'CV\'da shu tartibda chiqadi. Masalan: {example}',
    groupNative: 'Ona tili',
    groupCefr: 'CEFR darajalari',
    groupFree: 'Erkin',
    native: 'Ona tili (Native)',
    a1: 'A1 — Boshlang\'ich',
    a2: 'A2 — Elementar',
    b1: 'B1 — O\'rtacha',
    b2: 'B2 — Yuqori o\'rtacha',
    c1: 'C1 — Ilg\'or',
    c2: 'C2 — Mukammal',
    conversational: 'Suhbat darajasi',
    confident: 'Ishonchli',
    fluent: 'Erkin',
    langs: {
      uzbek: 'O\'zbek',
      russian: 'Rus',
      english: 'Ingliz',
      korean: 'Koreys',
      turkish: 'Turk',
      german: 'Nemis',
      french: 'Fransuz',
      italian: 'Italyan',
      spanish: 'Ispan',
      arabic: 'Arab',
      chinese: 'Xitoy',
      japanese: 'Yapon',
      polish: 'Polyak',
      czech: 'Chex',
      kazakh: 'Qozoq',
      kyrgyz: 'Qirg\'iz',
      tajik: 'Tojik',
      persian: 'Fors (Dari)',
      ukrainian: 'Ukrain',
      turkmen: 'Turkman',
    },
  },

  botSurveys: {
    title: 'Bot orqali olingan anketalar',
    searchPlaceholder: 'Ism, telefon, telegram...',
    fullName: 'F.I.O.',
    phone: 'Telefon',
    purpose: 'Maqsad',
    destination: 'Davlat',
    telegram: 'Telegram',
    date: 'Sana',
    actions: 'Amallar',
    view: "Ko'rish",
    delete: "O'chirish",
    confirmDelete: "Bu anketani o'chirishni xohlaysizmi?",
    confirmDeleteTitle: 'Tasdiqlash',
    deleteSuccess: "Anketa o'chirildi",
    detailTitle: 'Anketa tafsilotlari',
    dob: "Tug'ilgan sana",
    timeline: 'Ketish rejasi',
    education: "Ta'lim",
    specialty: 'Mutaxassislik',
    workExp: 'Ish tajribasi',
    intlExp: 'Chet el tajribasi',
    languages: 'Tillar',
    criminal: 'Sudlanganlik',
    visa: 'Viza rad',
    travelBan: 'Chiqish taqiqi',
    marital: 'Oilaviy holat',
    jobInterest: 'Qiziqtirgan ish',
    profession: 'Kasb/mutaxassislik',
    wishes: 'Shaxsiy istaklar',
  },

  network: {
    serverError: "Server bilan bog'lanishda xatolik",
    forbidden: 'Ruxsat berilmagan',
    offline: "Internet uzilgan — qaytganda o'zi yangilanadi",
    slow: "Aloqa sekin, qayta urinilmoqda...",
  },

  email: {
    dialogTitle: 'Tanlangan vakansiyalarga email yuborish',
    senderLabel: 'Qaysi email dan yuborilsin?',
    customSender: "Qo'lda kiritish",
    customEmailPh: 'sizning@email.com',
    customPassPh: 'Gmail App Password',
    saveSender: 'Keyingi safarga saqlash',
    appPasswordHint: "Gmail > Xavfsizlik > 2FA > App Passwords dan olinadi",
    templateLabel: 'Shablon',
    selectTemplate: 'Shablonni tanlang (ixtiyoriy)',
    saveAsTemplate: 'Shablon sifatida saqlash',
    deleteTemplate: "Shablonni o'chirish",
    subjectLabel: 'Mavzu',
    subjectPh: "Masalan: Hamkorlik taklifi",
    bodyLabel: 'Matn',
    bodyPh: "Assalomu alaykum,\nBiz — Oasis Visa agentligi...",
    recipientsLabel: 'Qabul qiluvchilar',
    noEmail: "email yo'q",
    more: 'yana',
    noEmailWarn: "{count} ta vakansiyada email yo'q — ularga yuborilmaydi",
    sendBtn: 'Yuborish ({count} ta)',
    sentAll: '{count} ta email muvaffaqiyatli yuborildi',
    sentPartial: '{ok} ta yuborildi, {fail} ta xato',
    sentFailed: "Email yuborilmadi",
    templateNamePh: 'Shablon nomi',
    templateNameRequired: 'Shablon nomini kiriting',
    templateSaved: 'Shablon saqlandi',
    templateDeleted: "Shablon o'chirildi",
    confirmDeleteTpl: "Shablonni o'chirmoqchimisiz?",
    subjectBodyRequired: "Avval mavzu va matnni to'ldiring",
    markDefault: "Standart shablon qilib belgilash",
    bulkEmailBtn: 'Email yuborish',
  },

  analytics: {
    myStatsTitle: 'Mening statistikam',
    employeesTitle: 'Hodimlar monitoringi',
    employeesSub: 'Kim qachon online, qanday ish qilgan — real vaqtda kuzating',
    day: 'Bugun',
    week: 'Shu hafta',
    month: 'Shu oy',
    activeTime: 'Aktiv vaqt',
    realWorkTime: 'Haqiqiy ish vaqti (bekor turmasdan)',
    vacancies: 'Vakansiyalar',
    partnersAdded: 'Qo\'shilgan hamkorlar',
    partners: 'Hamkorlar',
    clientsWorked: 'Mijozlar',
    clientsAssigned: 'Yangi mijozlar',
    stageChanged: 'Bosqichga o\'tkazildi',
    completed: 'Yakunlandi',
    online: 'Online',
    onlineNow: 'Hozir online',
    lastSeen: 'Oxirgi faollik',
    totalHours: 'Umumiy soat',
    employee: 'Hodim',
    activity: 'Faollik',
    roleAdmin: 'Administrator',
    roleEmployee: 'Xodim',
    noEmployees: 'Hodimlar topilmadi',
    neverLoggedIn: 'Hech qachon kirmagan',
    justNow: 'hozirgina',
    minutesAgo: '{n} daqiqa oldin',
    hoursAgo: '{n} soat oldin',
    daysAgo: '{n} kun oldin',
    lvlInactive: 'Nofaol',
    lvlLow: 'Past',
    lvlMedium: 'O\'rtacha',
    lvlGood: 'Yaxshi',
    lvlHigh: 'Yuqori',
    lvlElite: 'Eng yuqori',
  },
  pwa: {
    title: "Ilovani o‘rnating",
    desc: "Telefoningizga o‘rnating — tezroq ochiladi va brauzersiz ishlaydi.",
    iosHint: "Pastdagi “Share” tugmasini bosing, keyin “Add to Home Screen”.",
    install: "O‘rnatish",
    later: "Keyinroq",
  },
  cases: {
    title: "Ishlar (Cases)",
    newCase: "Yangi ish qo'shish",
    dashboard: "Nima kutyapti? (Dashboard)",
    refresh: "Yangilash",
    criticalRisks: "CRITICAL Xatarlar",
    noCriticalRisks: "Ayni paytda ochiq CRITICAL xatarlar yo'q",
    pendingApprovals: "Kutilayotgan Tasdiqlar",
    noPendingApprovals: "Tasdiq kutayotgan ishlar yo'q",
    stagnantTasks: "Muzlab qolgan vazifalar (>3 kun)",
    noStagnantTasks: "Harakatlanmayotgan vazifalar yo'q",
    caseDetail: "Kartochka dela",
    client: "Mijoz",
    country: "Davlat",
    serviceType: "Xizmat turi",
    status: "Holati",
    targetDate: "Topshirish sanasi",
    actions: "Harakatlar",
    open: "Ochish",
    changeStatus: "Statusni o'zgartirish",
    selectStatus: "Statusni tanlang",
    transition: "O'tish",
    tabs: {
      documents: "Hujjatlar matritsasi",
      facts: "Faktlar",
      risks: "Xatarlar (Risks)",
      approvals: "Tasdiqlar (Approvals)"
    },
    doc: {
      document: "Hujjat",
      requirement: "Talab",
      status: "Holati",
      file: "Fayl",
      deadline: "Muddat (Dedlayn)",
      mandatory: "Majburiy",
      conditional: "Shartli",
      no: "Yo'q",
      download: "Yuklab olish",
      noFile: "Fayl yo'q"
    },
    fact: {
      key: "Kalit",
      value: "Qiymat",
      source: "Manba",
      level: "Manba darajasi",
      status: "Holati",
      checkedAt: "Tekshirilgan vaqt"
    },
    risk: {
      closeRisk: "Xatarni yopish",
      closedBy: "Yopildi",
      noRisks: "Hech qanday xatar topilmadi",
      reason: "Yopish sababi",
      reasonPlaceholder: "Masalan: Pasport haqiqatda ikkita...",
      submitClose: "Yopish va Blokni Olish"
    },
    approval: {
      step: "Bosqich",
      status: "Holati",
      requestedAt: "So'ralgan vaqt",
      decidedAt: "Qaror vaqti",
      note: "Izoh",
      approve: "Tasdiqlash",
      reject: "Rad etish",
      pending: "Kutilmoqda",
      approved: "Tasdiqlandi",
      rejected: "Rad etildi"
    },
    statuses: {
      yangi: "Yangi",
      hujjat_yigilmoqda: "Hujjat yig'ilmoqda",
      hujjatlar_tayyor: "Hujjatlar tayyor",
      jonatildi: "Jo'natildi (Podacha)",
      viza_kutilmoqda: "Viza kutilmoqda",
      viza_oldi: "Viza oldi",
      bekor: "Bekor qilindi",
      stopped_by_risk: "Xavf tufayli to'xtatildi"
    }
  },
  dv: {
    title: "Green Card (DV) anketalari",
    subtitle: "Mijozlarning DS-5501 anketasi shablon sifatida: ro'yxatdan o'tish ochilishi bilan ma'lumot, rasm va pasport skani tekshirilgan holda tayyor turadi. Ariza faqat dvprogram.state.gov da, mijoz yonida topshiriladi.",
    yangi: "Yangi anketa",
    qidirish: "Ism, pasport, telefon, email yoki Confirmation Number",
    meniki: "Faqat meniki",
    ta: "ta",
    bosh: "Hali anketa yo'q",
    ishtirokchi: "Ishtirokchi",
    ismsiz: "(ismsiz)",
    telefon: "Telefon",
    crmMijoz: "CRM mijozi",
    tayyorlik: "Tayyorlik",
    xato: "xato",
    xatosiz: "xatosiz",
    holati: "Holati",
    oila: "Oila",
    yangilangan: "Yangilangan",
    crmdan: "CRM mijozidan",
    boshAnketa: "Bo'sh anketa",
    mijozIzla: "Familiya, ism yoki pasport bo'yicha qidiring",
    crmdanIzoh: "Ism, tug'ilgan sana, pasport, telefon, email va manzil CRM dan to'ldiriladi — har birini pasport bilan solishtiring. Otasining ismi Middle Name ga yozilmaydi.",
    boshIzoh: "Mijoz hali CRM da bo'lmasa — keyin anketa ichidan CRM mijoziga bog'lash mumkin.",
    ochish: "Ochish",
    holat: {
      qoralama: "Qoralama",
      tayyor: "Tayyor",
      topshirildi: "Topshirildi",
      yutdi: "Yutdi",
      yutmadi: "Yutmadi",
      bekor: "Bekor"
    },
    royxat: "Ro'yxat",
    bekorQil: "O'zgarishni bekor qilish",
    saqlash: "Saqlash",
    bekorQilish: "Anketani bekor qilish",
    tiklash: "Tiklash",
    ochirish: "Butunlay o'chirish",
    bekorQilingan: "Anketa bekor qilingan — tahrirlash uchun avval tiklang (menyu ⋯).",
    oilaAzolari: "Oila a'zolari",
    keyingi: "Keyingi",
    tekshirish: "Tekshirish",
    olibTashlash: "Ro'yxatdan olib tashlash",
    turmushQosh: "Turmush o'rtog'ini qo'shish",
    farzandQosh: "Farzand qo'shish",
    tuzatishKerak: "Tuzatish kerak",
    xatoYoq: "Xato yo'q — anketa ro'yxatdan o'tishga tayyor.",
    tekshiribKoring: "Tekshirib ko'ring",
    shpargalka: "Shpargalka (rasmiy forma tartibida)",
    yangilash: "Yangilash",
    nusxalash: "Nusxalash",
    shpIzoh: "Ro'yxatdan o'tish kuni dvprogram.state.gov da mijoz yonida shu matndan maydonma-maydon to'ldiriladi. Sanalar formadagidek OY / KUN / YIL.",
    saqlanmagan: "Saqlanmagan o'zgarishlar bor — shpargalka oxirgi saqlangan holatni ko'rsatadi.",
    tayyor: "tayyor",
    topshirishgaTayyor: "Ro'yxatdan o'tishga tayyor",
    mijozBogla: "CRM mijoziga bog'lash",
    topshirish: "Topshirish",
    topshirishIzoh: "Rasmiy saytda yuborilgach chiqqan 16 belgili Confirmation Number — natija faqat shu raqam bilan tekshiriladi.",
    raqamniYangila: "Raqamni yangilash",
    topshirildiDeb: "Topshirildi deb belgilash",
    natija: "Natija",
    kutilmoqda: "Kutilmoqda",
    izoh: "Xodim izohi",
    izohPh: "Mijozga ko'rinmaydi",
    yaratgan: "Yaratgan",
    ozgartirgan: "O'zgartirgan",
    saqlangan: "Saqlangan",
    ozgarishYoq: "O'zgarish yo'q — hammasi saqlangan",
    saqlanmaganQisqa: "Saqlanmagan o'zgarishlar",
    saqlandi: "Saqlandi",
    saqlandiTayyor: "Saqlandi — anketa ro'yxatdan o'tishga tayyor",
    xatoQoldi: "ta xato qoldi"
  }
}
